
<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row">
      <div class="d-block d-md-none">
      <b-button variant="primary" class="btn-sm" @click="showSidebar = true"> Category </b-button>
        <b-sidebar id="sidebar" title="Filter By Category" :visible="showSidebar" @hidden="showSidebar = false" backdrop >
        <div class="p-3"> 
          <div v-for="item in categories" :key="item.id">
            <b-card no-body class="mb-2 p-0 shadow-lg">
              <b-card-header header-tag="header" role="tab" class="bg-success rounded-3">
                <span class="p-0"><a v-b-toggle="'accordion-'+item.id" class="text-white d-flex justify-content-between" href="javascript: void(0);"> {{ item.name }} <i class="mdi mdi-chevron-down"></i></a></span>
              </b-card-header>
              <b-collapse :id="'accordion-'+item.id" accordion="my-accordion" role="tabpanel">
                  <b-card-body class="py-2">
                  <div v-for="item in item.subcategories" :key="item.id" class="mb-2">
                  <a href="javascript: void(0);" @click="FindByCategory(item.id)" class="text-dark"><i class="mdi mdi-chevron-right me-1"></i> {{ item.name }}</a>
                  </div>
                </b-card-body>
              </b-collapse>
            </b-card>
          </div>
          <b-button variant="secondary" class="btn-sm" @click="showSidebar = false"> Close</b-button>
        </div>
      </b-sidebar>
    </div>
      <div class="col-lg-3 col-sm-3 d-none d-lg-block">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title mb-4">Filter By Category</h4>
              <div v-for="item in categories" :key="item.id">
                <b-card no-body class="mb-2 p-0 shadow-lg">
                  <b-card-header header-tag="header" role="tab" class="bg-success rounded-3">
                    <span class="p-0"><a v-b-toggle="'accordion-'+item.id" class="text-white d-flex justify-content-between" href="javascript: void(0);"> {{ item.name }} <i class="mdi mdi-chevron-down"></i></a></span>
                  </b-card-header>
                  <b-collapse :id="'accordion-'+item.id" accordion="my-accordion" role="tabpanel">
                     <b-card-body class="py-2">
                      <div v-for="item in item.subcategories" :key="item.id" class="mb-2">
                      <a href="javascript: void(0);" @click="FindByCategory(item.id)" class="text-dark"><i class="mdi mdi-chevron-right me-1"></i> {{ item.name }}</a>
                      </div>
                    </b-card-body>
                  </b-collapse>
                </b-card>
              </div>
            </div>
          </div>
        </div>
      <div class="col-md-9 col-12 mx-auto">
        <div class="row mb-3">
          <div class="col-xl-4 col-sm-6"><div class="mt-2"></div></div>
          <div class="col-lg-8 col-sm-6">
            <form class="mt-4 mt-sm-0 float-sm-end d-flex align-items-center">
              <div class="search-box me-2">
                <div class="position-relative">
                  <input type="search" class="form-control border-0" placeholder="Search..." @input="filterProduct($event)"/>
                  <i class="bx bx-search-alt search-icon"></i>
                </div>
              </div>
              <ul class="nav nav-pills product-view-nav">
                <li class="nav-item"><a class="nav-link active" href="javascript: void(0);"><i class="bx bx-grid-alt"></i></a></li>
                <li class="nav-item"><a class="nav-link" href="javascript: void(0);"><i class="bx bx-list-ul"></i></a></li>
              </ul>
            </form>
          </div>
        </div>
        <div class="row">
          <div v-for="data in products" :key="data.id" class="col-md-3 col-6 mt-2">
            <div class="p-2 shadow-lg">
                <div class="product-img position-relative">
                  <div class="product-ribbon"><span class="bg-primary text-white small p-2 rounded-2">{{ data.category.name }}</span></div>
                    <div style="height: 180px; display: flex; justify-content: center; align-items: center; overflow: hidden; border-radius: 2px 20px;">
                      <img :src="getFiles(data.photo)" class="rounded-3 shadow-lg"/>
                    </div>
                </div>
                <div class="mt-0 p-2 mt-2">
                  <div>
                    <h6 class="text-truncate mb-0">{{ data.name }}</h6>
                    <span class="my-0">AED {{ commas(data.price) }}</span>
                    <!-- <b-form-rating variant="warning" v-model="value" style="border: none;"></b-form-rating> -->
                  </div>
                  <div class="mt-1">
                    <router-link :to="{ path: '/product', query: { id: data.product_id }}">
                      <span class="btn-outline-primary btn-sm btn" size="sm"> <i class="mdi mdi-calendar"></i> Book Now</span>
                    </router-link>
                  </div>
              </div>
              </div>

          </div>
        </div>

        <div class="row">
          <div class="col-lg-12">
            <b-pagination
              v-if="products.length > 0" class="justify-content-center" v-model="currentPage" :total-rows="products.length" :per-page="6" ></b-pagination>
          </div>
        </div>

        <div v-if="products.length<=0" class="text-center p-4">
          <i class="fas fa-shopping-cart fa-4x"></i>
          No Services Found<br><br>
          <router-link tag="a" to="/products" class="btn btn-sm btn-success" >View Services</router-link>
      </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import axios from "axios";
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
// import StarRating from 'vue-star-rating';
import appConfig from "@/app.config";
import { productMethods, productComputed, categorieMethods, categorieComputed,cartMethods, cartComputed } from "@/state/helpers";

export default {
  page: {
    title: "Booking Place",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout, PageHeader },
  data() {
    return {
      title: "Products / Services",
      items: [
        {text: "Ecommerce",href: "/",},
        {text: "Products",active: true, },
      ],
      sliderPrice: 150000,
      currentPage: 1,
      showSidebar:false,
      value:3,
    };
  },
  mounted() {
    this.fetchProducts();
    this.fetchCarts();
    this.fetchCategories();
  },
  computed: {
    ...productComputed,
    ...categorieComputed,
    ...cartComputed,
  },
  methods: {
    ...productMethods,
    ...categorieMethods,
    ...cartMethods,
    getFiles(name){
      let url = axios.defaults.baseURL;
      let imagelink = (url).slice(0,-3)+"products/"+name;
      return imagelink;
    },
    commas(x) { return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','); },
    valuechange() {
      this.filterPrice({search:this.sliderPrice});
    },
    filterProduct(e) {
      const search = e.target.value;
      this.filterProducts({search:search});
    },
    FindByCategory(category){
      this.filterProductsByCategory({category:category});
    },
  },
};
</script>

<style>
.slider {
  width: 200px;
}
</style>